/* eslint-disable no-eval */
/* eslint-disable no-param-reassign */
import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import { formatNumber } from 'utils/number';
import tradingDataStore from 'lib/stores/tradingData';
import orderbookModalStore from './store';
import { PreviewItem } from './styled';

function AmendBuyPreview() {
  const {
    configFormula: {
      data: { formula },
    },
  } = tradingDataStore();
  const { price, orders } = orderbookModalStore();

  const dataPreview = orders.reduce(
    (acc, cur) => {
      const LOT = cur.order_total;
      const PRICE = price;
      const FEE_BUY = formula.fee_buy;
      const BUY_AMOUNT = eval(formula.buy_amount_invested); // nosemgrep
      const BUY_AMOUNT_FEE = eval(formula.buy_amount_invested_fee); // nosemgrep
      const BUY_FEE = eval(formula.buy_amount_fee); // nosemgrep

      acc.stock = cur.symbol;
      acc.price = PRICE;
      acc.lot += LOT;
      acc.investment += BUY_AMOUNT;
      acc.fee += BUY_FEE;
      acc.total_investment += BUY_AMOUNT_FEE;

      return acc;
    },
    {
      stock: '',
      price: 0,
      lot: 0,
      investment: 0,
      fee: 0,
      total_investment: 0,
    },
  );

  const previewData = [
    {
      label: <Text>Stock</Text>,
      value: <Text family="bold">{dataPreview.stock}</Text>,
    },
    {
      label: <Text>Price</Text>,
      value: <Text>{formatNumber(dataPreview.price, false)}</Text>,
    },
    {
      label: <Text>Lot</Text>,
      value: <Text>{formatNumber(dataPreview.lot, false)}</Text>,
    },
    {
      label: <Text>Investment</Text>,
      value: <Text>Rp {formatNumber(dataPreview.investment, false)}</Text>,
    },
    {
      label: <Text>Fee</Text>,
      value: <Text>Rp {formatNumber(dataPreview.fee, false)}</Text>,
    },
    {
      label: <Text family="bold">Investment (Plus Fee)</Text>,
      value: (
        <Text family="bold">
          Rp {formatNumber(dataPreview.total_investment, false)}
        </Text>
      ),
    },
  ];

  return (
    <Flex direction="column" width="100%">
      {previewData.map((p) => (
        <PreviewItem key={`amend-buy-${p.label}`}>
          {p.label}
          {p.value}
        </PreviewItem>
      ))}
    </Flex>
  );
}

export default AmendBuyPreview;
